import { useEffect } from 'react'
import { Stack } from '@mui/material'
import { SPACING } from '@common/theme/spacing'
import { useLocation, useParams } from 'react-router-dom'
import { StudyQueryListSchema } from '@common/config/api/client'
import QueriesTableSkeleton from '@features/study_details/Queries/components/QueriesTableSkeleton'
import QueriesTable from '@features/study_details/Queries/components/QueriesTable'
import CreateQueryDrawer from '@features/study_details/Queries/components/CreateQueryDrawer'
import ViewOrEditQueryDrawer from '@features/study_details/Queries/components/ViewOrEditQueryDrawer'
import { useQueriesManagementHandlers } from '@features/study_details/Queries/hooks/useQueriesManagementHandlers'
export default function SubjectQueries() {
  const { studyId, subjectId } = useParams<{
    studyId: string
    subjectId: string
  }>()

  const location = useLocation()

  const {
    page,
    queryListParams,
    isCreateDrawerOpen,
    handleCreateQueryClick,
    handleCloseCreateDrawer,
    handleSubmitCreateQuery,
    isViewDrawerOpen,
    selectedQueryDetails,
    isLoadingDetails,
    isLoadingMetadata,
    isErrorDetails,
    handleViewQueryClick,
    handleCloseViewDrawer,
    queriesResponse,
    isLoadingList,
    handlePageChange,
    handleRowsPerPageChange,
    handleSearch,
    handleRequestSort,
    handleUpdateStatus,
    handleSendMessage,
    handleUpdateQuery,
    isUpdatingStatus,
    isSendingMessage,
    isUpdatingQuery,
    setQueryListParams,
  } = useQueriesManagementHandlers()

  useEffect(() => {
    if (studyId && subjectId) {
      setQueryListParams((prev) => ({
        ...prev,
        subject_id: subjectId,
        next_cursor: undefined,
        previous_cursor: undefined,
      }))
    }
  }, [studyId, subjectId, setQueryListParams])

  useEffect(() => {
    if (location.state?.openCreateQueryDrawer) {
      handleCreateQueryClick()
      window.history.replaceState({}, document.title)
    }
  }, [location.state, handleCreateQueryClick])

  if (!studyId || !subjectId) {
    return <div>Loading study information...</div>
  }

  return (
    <>
      <Stack spacing={SPACING.sectionsSpacing}>
        {isLoadingList ? (
          <QueriesTableSkeleton />
        ) : (
          <QueriesTable
            queries={queriesResponse!}
            page={page}
            orderBy={queryListParams.order_by_field as keyof StudyQueryListSchema}
            order={queryListParams.asc_order ? 'asc' : 'desc'}
            searchValue={queryListParams.search ?? ''}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onSearch={handleSearch}
            onRequestSort={handleRequestSort}
            onCreateClick={handleCreateQueryClick}
            onViewClick={handleViewQueryClick}
            hideSubjectColumn
          />
        )}
      </Stack>

      <CreateQueryDrawer
        studyId={studyId}
        open={isCreateDrawerOpen}
        onClose={handleCloseCreateDrawer}
        onSubmit={handleSubmitCreateQuery}
        subjectId={subjectId}
      />

      {(isViewDrawerOpen || isLoadingDetails || isLoadingMetadata) && (
        <ViewOrEditQueryDrawer
          open={isViewDrawerOpen}
          onClose={handleCloseViewDrawer}
          query={selectedQueryDetails!}
          isLoading={isLoadingDetails}
          isError={isErrorDetails}
          onUpdateStatus={handleUpdateStatus}
          onSendMessage={handleSendMessage}
          onUpdateQuery={handleUpdateQuery}
          isUpdatingStatus={isUpdatingStatus}
          isSendingMessage={isSendingMessage}
          isUpdatingQuery={isUpdatingQuery}
        />
      )}
    </>
  )
}
